import { createFileRoute } from '@tanstack/react-router';

import { requireAdmin } from '@/components/admin/require-admin.ts';
import { SubjectListPage } from '@/views/admin/subject-list-page.tsx';

export const Route = createFileRoute('/admin/subjects')({
  beforeLoad: requireAdmin,
  component: SubjectListPage,
});
